import { SettingConst } from '../../types';

/**
 * Control whether we will return FilterablePaginatedSection in SDUI layout API response
 */
export const ENABLE_FILTERABLE_PAGINATED_SECTION_240325 =
  'ENABLE_FILTERABLE_PAGINATED_SECTION_240325' as SettingConst<
    'ENABLE_FILTERABLE_PAGINATED_SECTION_240325',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'RETAILER_HEAD_TAGS'
  >;
